




import {Component, Prop, Vue} from "vue-property-decorator";
import {FreightServiceAddStore} from "../../store";

@Component({
    name: "FreightServiceAddLabel"
})
export default class extends Vue {
    @Prop({ required: true, type: String })
    readonly id!: string;

    get label() {
        return `${FreightServiceAddStore.data[this.id]?.code} - ${FreightServiceAddStore.data[this.id]?.name}`;
    }
}
